import type { Video } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

interface VideoGridProps {
  title: string;
  subtitle?: string;
  videos: Video[];
  columns?: number;
  viewAllHref?: string;
}

export default function VideoGrid({ title, subtitle, videos, columns = 4, viewAllHref }: VideoGridProps) {
  const gridCols = columns === 6 ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6' :
                    columns === 5 ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5' :
                    'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4';

  return (
    <section className="w-full px-4 md:px-6 py-8" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="text-lg font-bold text-foreground-900">{title}</h2>
            {subtitle && (
              <p className="text-xs text-foreground-400 mt-1">{subtitle}</p>
            )}
          </div>
          {viewAllHref && (
            <a
              href={viewAllHref}
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          )}
        </div>

        {/* Grid */}
        <div className={`grid ${gridCols} gap-4 md:gap-5`}>
          {videos.slice(0, columns === 6 ? 6 : 8).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}